import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "./Login.scss";
import logo from "../../assets/images/logo.png";
import { useForm } from 'react-hook-form';
import workshop from "../../assets/images/workshop.png";
import masterApi from "../../services/masterApi";
import { UserRolesEnum} from "../../enum/enums";


const Login = () => {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm()
  const [error, setError] = useState()
  const [viewLoader, setViewLoader] = useState(false);
  const { login, user,setUser } = useContext(AuthContext);
  const [keepLoggedIn, setKeepLoggedIn] = useState(false); // State for "Keep me logged in"
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) {
      if(user?.userRole==UserRolesEnum.TECHINICIAN){
        navigate("/techniciandashbaord");
      }else{
      navigate("/dashboard");
      }
    }
  }, [navigate, user]);

  const onSubmit = async (data) => {
    setViewLoader(true)
    try {
      data.email = data.email.trim();
      data.username = data.email;
      
      const userData = await masterApi.login({ data }); 
      if (userData?.data?.ok) {
        setUser(userData?.data?.user);
        
        localStorage.setItem("user", JSON.stringify(userData?.data?.user));// Store token in localStorage
        localStorage.setItem("token", userData?.data?.serviceToken);// Store token in localStorage
        //const { from } = location.state || { from: { pathname: "/dashboard" } };
        if(userData?.data?.user.userRole == UserRolesEnum.TECHINICIAN){
          navigate("/techniciandashbaord");
        }else{
          navigate("/dashboard");
        }

        //navigate(from);
      }else{
        setViewLoader(false)
        setError(userData?.message)
      }
    } catch (error) {
      setViewLoader(false)
      setError('Someting went wrong!')
      console.error('Login failed:', error.message);
    }
  }


  return (
    <div className="main-login-area">
      <div className="login-box">
       <div className="box-left">
       <div className="login-content-area">
          <div className="logo-area">
            <div className="logo-box">
              <div className="logo-img">
                <img src={logo} alt="" />
              </div>
              <div className="logo-heading">Scheduler</div>
            </div>
          </div>
          <div className="login-input-area">
            <h2 className="heading space-between">LOGIN</h2>
            <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>
            <input {...register('email',{
                required: true,                
              })}
              className={`${errors.email ? 'input required' : ' input'}`}
              type="text"
              placeholder="User Name / Email"
            />
            <input {...register('password', { required: "Password is required" })} 
              className={`${errors.password ? 'input required' : ' input'}`}
              type="password"
              placeholder="Password"             
            />
            {error && <div className="alert">Email or Password is incorrect</div>}
              <button className="button" type="submit">
                {viewLoader && (
                  <div className="loder-wrapper">
                    <span className="loader-icon"></span>
                  </div>
                )}
                LOGIN
              </button>
            </form>
            <div className="forgot-area space-between">
              <div className="keep-login">
                {/*<input
                  className="dnone-input"
                  id="keeploggedin"
                  type="checkbox"
                  checked={keepLoggedIn}
                  onChange={() => setKeepLoggedIn(!keepLoggedIn)}
                />
                <label htmlFor="keeploggedin" className="keeploggedin-box">
                  Keep me logged in
                </label>*/}
              </div>
              <div className="forgot-password">
                <Link to="/forgotpassword">Forgot password?</Link>
              </div>
            </div>
            {/*<div className="signup-area space-between">
              Don’t have an account? <Link to="/register">SIGN UP</Link>
            </div>*/}
          </div>
        </div>
       </div>
       <div className="box-right">
          <img src={workshop} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Login;
